import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import './styles.scss';
import { compose } from 'redux';
import * as fonts from '../../../../util/fonts';

import AppWrapper from '../../../../components/app-wrapper';
import { strings } from '../../../../util/strings';
import { addToGlobalStyles, addToWizard, setWizard } from '../../../../store/actions';

import colors from '../../../../util/colors';
import { Column, Row } from '../../../../components/layout';
import Stepper from '../../../../components/stepper';
import Header2 from '../../../../components/headers/header2/Header2';
import Icon from '../../../../components/icon';
import { Icons } from '../../../../util/icons';
import DataValidation from './data-validation/DataValidation';
import AttachFiles from './../../../reimbursements/reimbursement-request/steps/invoice-validation/attach-files/index';
import NewPatientValidation from '../../../reimbursements/reimbursement-request/steps/new-patient-validation';
import { uriGetDocumentTypes } from '../../../../api/endpoints';
import { get } from '../../../../api/api';

export interface PreAuthorizationRequestProps {
  wizard: any;
  setWizard(value: any): void;
  user: any;
  addToGlobalStyles(value: any): void;
  selectedBu: any;
  labels: typeof strings.pt.preAuthorizations;
  labelsCreateRefund: typeof strings.pt.createRefund;
  addToWizard(value: any): void;
  buStyles: any;
}

const PreAuthorizationRequest: React.FC<PreAuthorizationRequestProps> = ({
  addToWizard,
  wizard,
  setWizard,
  buStyles,
  labels,
  labelsCreateRefund,
  selectedBu,
}) => {
  const [step, setStep] = useState(0);
  const [currentStepValid, setCurrentStepValid] = useState(false);
  const [documentTypes, setDocumentTypes] = useState<any[]>([]);
  const location = useLocation();

  async function getTypesOfDocumentsOptions() {
    const response: any = await get(uriGetDocumentTypes());
    const typeOfDocuments = response.data.documentTypes;

    let newProceed: any[] = [];

    setDocumentTypes(
      (typeOfDocuments as any).map((item: any) => {
        newProceed.push({...item});

        return {
          value: item.code,
          label: item.description,
        };
      })
    );
  }

  useEffect(() => {
    if (location.pathname.includes('pre-aut')) {
      getTypesOfDocumentsOptions();
    }
  }, []);

  return (
    <>
      <Column className="preauthorization-main-column">
        <Column className="preauthorization-container">
          <Column>
            <Row className="preauthorization-header-row">
              <Header2
                className="preauthorization-header"
                style={{
                  ...fonts.XL,
                  ...fonts.Bold,
                  color: colors.black,
                }}
              >
                {labels?.authorization_requestOfPreAuthorization}
              </Header2>
            </Row>
            <Row className="preauthorization-subtitle-row">
              <p style={{ ...fonts.M, color: colors.black }}>
                {labels?.authorization_responseIn72hours}
              </p>
            </Row>
          </Column>
          <Stepper
            className="preauthorization-stepper"
            step={wizard.step}
            currentStepValid={currentStepValid}
            steps={[
              {
                index: 0,
                label: labels?.authorization_patient,
                component: (onSubmit: any, nextStepHandler: any) => (
                  <NewPatientValidation
                    onSubmit={onSubmit}
                    nextStep={nextStepHandler}
                    hideExit={true}
                    validationMethod={() => true}
                    functionalityAtiva={'pre-autorizacoes'}
                  />
                ),
                onSubmit: (values: any) =>
                  addToWizard({ insuranceValidation: { ...values } }),
              },
              {
                index: 1,
                label: labels?.authorization_documents,
                component: (onSubmit: any, nextStepHandler: any) => (
                  <AttachFiles
                    onSubmit={onSubmit}
                    valid={currentStepValid}
                    setValid={(valid: any) => {
                      if (valid !== currentStepValid) setCurrentStepValid(valid);
                    }}
                    titleOfButton={labels?.authorization_confirm}
                    showPopup={true}
                    nextStep={nextStepHandler}
                    selectedBu={selectedBu.buId}
                    nextStepFlag={true}
                    labelFiles={labels?.preAuthorizations_addClinicInfo}
                    setWizard={setWizard}
                    addToGlobalStyles={addToGlobalStyles}
                    documentTypes={documentTypes} />
                ),
                onSubmit: (values: any) =>
                  addToWizard({ dataValidation: { ...values } }),
              },
              {
                index: 2,
                label: labels?.authorization_data,
                component: (onSubmit: any, nextStepHandler: any) => (
                  <DataValidation
                    onSubmit={onSubmit}
                    setValid={(valid: any) => {
                      if (valid !== currentStepValid) setCurrentStepValid(valid);
                    }}
                    valid={currentStepValid}
                  />
                ),
                onSubmit: (values: any) =>
                  addToWizard({ ActivateAccount: { ...values } }),
              },
            ]}
          />
          <Link
            onClick={() => {
              setWizard({});
            }}
            to="/pre-autorizacoes"
            className="pre-authorization-header-content-exit-label"
            style={{
              ...fonts.SM,
              color: buStyles?.primaryColor || colors.fluorescentBlue,
              fontWeight: 'bold',
            }}
          >
            {labels?.authorization_leaveRequest}
            <Icon
              className="preauthorization-header-content-close-icon svg-close-button inline-svg-close-button"
              name={Icons.CLOSE}
              width={'12'}
              height={'12'}
              changeViewbox={true}
              strokeWidth={'0.5'}
            />
          </Link>
        </Column>
      </Column>
    </>
  );
};

const mapStateToProps = ({ selectedBu, user, strings, wizard, globalStyles }: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.preAuthorizations,
  labelsCreateRefund: strings.value.pt.createRefund,
  wizard: wizard.value,
  buStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(PreAuthorizationRequest)
);
